import React from 'react';
import PropTypes from 'prop-types';

import MusicServicesListItem from 'components/dashboard/music-links-content/MusicServicesListItem';

import './MusicServicesList.css';

function MusicServicesList({ item }) {
  if (item.music_service_links && item.music_service_links.length === 0) return null;

  return (
    <div className="music-links-services-list__component">
      {item.music_service_links.map(link => <MusicServicesListItem item={link} />)}
    </div>
  );
};

MusicServicesList.propTypes = {
  item: PropTypes.object.isRequired,
};

export default MusicServicesList;
